export function smoothScrollTo(target, options = {}) {
  const lenis = window.__lenis;
  if (lenis) {
    lenis.scrollTo(target, { duration: 1.1, ...options });
  } else if (typeof target === "number") {
    window.scrollTo({ top: target, behavior: "smooth" });
  } else {
    target?.scrollIntoView({ behavior: "smooth" });
  }
}
